export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,

  title: '角色权限',
} as TCommon.RouteConfig
